package com.anjuros.website.redesign.sections.pricing

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.jsonString
import com.anjuros.website.redesign.components.rdBreadcrumbJsonLd
import com.anjuros.website.redesign.components.rdFaqJsonLd
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL

/** JSON-LD for the Pricing page: every price as an offer, plus the breadcrumb and the FAQ. */
@Composable
fun pricingStructuredData(): String {
    val websiteOffers = WebsiteOption.entries.map { option ->
        val price = if (option.fromPrice) {
            """"priceSpecification":{"@type":"PriceSpecification","minPrice":"${option.offerPrice}","priceCurrency":"GBP"}"""
        } else {
            """"price":"${option.offerPrice}","priceCurrency":"GBP""""
        }
        """{"@type":"Offer","name":${jsonString(LocalText(option.title))},$price}"""
    }
    val planOffers = CarePlan.entries.map { plan ->
        """{"@type":"Offer","name":${jsonString(LocalText(plan.title))},"priceSpecification":{"@type":"UnitPriceSpecification","price":"${plan.offerPrice}","priceCurrency":"GBP","unitText":"MONTH"}}"""
    }
    val offers = (websiteOffers + planOffers).joinToString(",")
    val breadcrumb = rdBreadcrumbJsonLd(RdText.PRICING_CRUMB, RdRoute.PRICING)
    val faq = rdFaqJsonLd(PricingFaqs)
    return """
        {"@context":"https://schema.org","@graph":[
         {"@type":"Service","name":"Website design for UK sole traders","serviceType":"Website design","areaServed":"GB",
          "url":"$SITE_URL${RdRoute.PRICING}","provider":{"@id":"$SITE_URL/#business"},
          "hasOfferCatalog":{"@type":"OfferCatalog","name":"Websites and care plans","itemListElement":[$offers]}},
         $breadcrumb,
         $faq
        ]}
    """.trimIndent()
}
